import { fetchData } from "store/data/data.actions";
import { checkUserSession } from "store/user/user.action";
import { THEME_KEY } from "utils/helper/states";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { selectTheme } from "store/theme/theme.selector";
import { setTheme } from "store/theme/theme.action";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

export const trackAnalyticsEvent = (props: {
  category: string;
  action: string;
  label: string;
}) => {
  ReactGA.event(props);
};

export const alertMessage = (type: string, msg: string) => {
  const themeStore = localStorage.getItem(THEME_KEY);
  const theme =
    themeStore != null
      ? themeStore
      : window.matchMedia("(prefers-color-scheme: dark)")
      ? "dark"
      : "light";
  const toastC =
    type === "error"
      ? toast.error
      : type === "info"
      ? toast.info
      : type === "success"
      ? toast.success
      : type === "warn"
      ? toast.warn
      : toast;
  toastC(msg, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: theme,
  });
};
const InitialState = () => {
  const dispatch = useDispatch();
  const theme = useSelector(selectTheme);
  const location = useLocation();

  const isDashboardPage = location.pathname.startsWith("/dashboard");

  useEffect(() => {
    const localTheme = localStorage.getItem(THEME_KEY);
    if (
      localTheme == null &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      dispatch(setTheme("dark"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isDashboardPage) {
      if (theme === "dark") {
        document.querySelector("html")?.classList.add("dark");
        document.documentElement.setAttribute("data-theme", "dark");
      } else {
        document.querySelector("html")?.classList.remove("dark");
        document.documentElement.setAttribute("data-theme", "light");
      }
    } else {
      document.querySelector("html")?.classList.add("light");
      document.documentElement.setAttribute("data-theme", "light");
    }
  }, [isDashboardPage, theme, dispatch]);

  useEffect(() => {
    if (!isDashboardPage) dispatch(fetchData());
    dispatch(checkUserSession());
  }, [dispatch, isDashboardPage]);

  return (
    <>
      <ToastContainer />
    </>
  );
};

export default InitialState;
